import { render } from "./StaticList.vue?vue&type=template&id=38a23ea9&scoped=true"
import script from "./StaticList.vue?vue&type=script&lang=js"
export * from "./StaticList.vue?vue&type=script&lang=js"

import "./StaticList.vue?vue&type=style&index=0&id=38a23ea9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a23ea9"]])

export default __exports__